export const deletePost = /* GraphQL */ `
  mutation DeletePost($input: DeleteScreensightPostInput!, $condition: ModelScreensightPostConditionInput) {
    deletePost(input: $input, condition: $condition) {
      channelId
    }
  }
`
